export function withoutHiddenRows<T>(value: T): T {
  if (Array.isArray(value)) {
    return value
      .filter((item) => !(item && typeof item === "object" && (item as { hidden?: unknown }).hidden === true))
      .map((item) => withoutHiddenRows(item)) as T;
  }
  if (value && typeof value === "object") {
    return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, withoutHiddenRows(item)])) as T;
  }
  return value;
}
